import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

import { formatDate } from '../../utils';
import { getNotificationUrl } from './utils';

import StyledLink from '../StyledLink';

const StyledContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '0 1rem',
  '&:first-of-child': {
    paddingTop: '0.5rem',
  },
}));

const StyledHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '0.5rem',
  position: 'relative',
}));

const CUNotificationItemComponent = ({
  data,
  index,
  isViewed,
  onDrawerClose,
}) => {
  const item = data[index];
  if (!item) return null;

  const { subject, createdAt, message, viewed, metadata } = item;
  const url = getNotificationUrl(metadata);
  const title = url ? (
    <StyledLink to={url}>
      <span
        onClick={() => onDrawerClose()}
        onKeyPress={() => onDrawerClose()}
        role="button"
        tabIndex="0"
      >
        {subject}
      </span>
    </StyledLink>
  ) : (
    subject
  );
  const date = formatDate(createdAt, true);

  return (
    <StyledContainer>
      <StyledHeaderContainer>
        <Badge
          color="secondary"
          variant="dot"
          component="div"
          invisible={isViewed || viewed}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        />
        <Box
          sx={(theme) => ({
            color: theme.palette.custom.link,
            flex: 1,
            lineHeight: '1.9rem',
          })}
        >
          {title}
        </Box>

        <Box
          sx={(theme) => ({
            color: theme.palette.custom.notificationTime,
            fontSize: '1.4rem',
          })}
        >
          {date}
        </Box>
      </StyledHeaderContainer>
      <Box
        sx={(theme) => ({
          color: theme.palette.custom.notificationMessage,
          lineHeight: '1.9rem',
        })}
      >
        {message}
      </Box>
    </StyledContainer>
  );
};

CUNotificationItemComponent.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  index: PropTypes.number.isRequired,
  isViewed: PropTypes.bool.isRequired,
  onDrawerClose: PropTypes.func.isRequired,
};

export default CUNotificationItemComponent;
